<template>
  <div class="base-desc-root-container">
    <span class="base-desc-title">项目描述</span>
    <p>{{dataSource.more}}</p>
  </div>
</template>

<script>
import * as icon from "../../../common/icon";
export default {
  props:{
    dataSource:Object
  },
  components: {
  },
  data() {
    return {
      icons: icon,
    };
  },
  methods: {
  },
};
</script>

<style scoped>
.base-desc-root-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 20px 40px;
  background-color: #fff;
  border-radius: 14px;
}
.base-desc-title{
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 40px;
}
.base-desc-edit {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 23px;
  height: 23px;
  cursor: pointer;
}
</style>